import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from './router'
import ReaddyAgentWidget from './components/feature/ReaddyAgentWidget'

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppRoutes />
      <ReaddyAgentWidget />
    </BrowserRouter>
  )
}

export default App